import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'extractOriginDestination'
})
export class ExtractOriginDestinationPipe implements PipeTransform {
  transform(pageHeading: string, type: 'origin' | 'destination'): string {
    if (!pageHeading) return '';
    // Split the string and remove "Flights" from the result
    const [origin, destination] = pageHeading.split(' to ');
    const cleanOrigin = origin.trim().replace(' Flights', ''); // Remove "Flights" from origin
    const cleanDestination = destination.trim().replace(' Flights', ''); // Remove "Flights" from destination
    return type === 'origin' ? cleanOrigin : cleanDestination;
  }
}
